import md5 from "md5";
import React, { useContext } from "react";
import { GrigoraDashboardContext } from "../dashboard/context";
import classnames from "classnames";

function Avatar({
  style,
  memberID,
  emailID,
  size = 50,
  showTitle,
  className,
  ...props
}) {
  const { project, getImgSrcUrl } = useContext(GrigoraDashboardContext) ?? {};

  const classNames = classnames("rounded-full", className);

  const member =
    memberID && project?.members && project?.members[memberID]
      ? project?.members[memberID]
      : undefined;

  const memberEmail =
    memberID && project?.members && project?.members[memberID]?.email
      ? project?.members[memberID]?.email
      : emailID
      ? emailID
      : undefined;

  const memberEmailTrimmed = memberEmail?.trim()?.toLowerCase();

  let src;

  if (member?.avatar?.src && member?.avatar?.srcMode) {
    src = getImgSrcUrl(member?.avatar?.src, member?.avatar?.srcMode);
  } else {
    src = memberEmailTrimmed
      ? `https://www.gravatar.com/avatar/${md5(memberEmailTrimmed)}?d=mp&s=100`
      : `http://www.gravatar.com/avatar/?d=mp`;
  }

  return (
    <div
      style={{
        width: size,
        height: size,
      }}
      className={`rounded-full overflow-hidden`}
    >
      <img
        {...props}
        title={showTitle ? member?.name : undefined}
        className={`${classNames} object-cover w-full h-full`}
        src={src}
      />
    </div>
  );
}

export default Avatar;
